// extracted by mini-css-extract-plugin
export default {"confirm-product-card":"ConfirmProductCard_confirm-product-card__fmNRJ","image":"ConfirmProductCard_image__CkGdA"};